import React, { useState } from "react";
import "./OtherServices.css";
import ServiceAR from "../../Assests/ServiceAR.jpg";
import ServiceSRU from "../../Assests/ServiceSRU.jpg";
import ServiceNE from "../../Assests/ServiceNE (1).png";
import { Button } from "primereact/button";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import axios from "axios";
import { useHistory } from "react-router-dom";

let userSelectedLanguage;

const OtherServices = () => {
  const history = useHistory();
  userSelectedLanguage = localStorage.getItem("selectedLanguage");
  const [testState, setTestState] = useState(false);

  const test = () => {
    setTestState(true);
  };
  const navigateToAnnualReport = () => {
    localStorage.setItem("navigateTo", "companyInformation");
    localStorage.setItem("navigateToGUID", "");
    localStorage.setItem("navigatedCompanyName", "");
    localStorage.setItem("possibleAccessablePages", "");
    localStorage.setItem("appType", "Annual Report");
    history.push("/annualreport");
    window.location.reload(false);
    window.target = "_blank";
  };
  const NavigateToInk2 = async () => {
    try {
      localStorage.setItem("sruNavigateTo", "companyInfo");
      localStorage.setItem("navigateToGUID", "");
      localStorage.setItem("navigatedCompanyName", "");
      localStorage.setItem(
        "possibleAccessablePages",
        JSON.stringify(["My Dashboard"])
      );
      localStorage.setItem("appType", "Income Declaration");

      const response = await axios.get("/cms/generateUUID");

      const newReportGUID = response.data;

      console.log("UUID:", newReportGUID);

      window.location.href = `/income-declaration-2/${newReportGUID}/companyInfo`;
      window.target = "_blank";
    } catch (error) {
      console.error("Error generating UUID:", error);
    }
  };
  const servicesList = [
    {
      image: ServiceAR,
      title: "Annual Report",
      description:
        "For those who only need to draw up an annual report (K2) and submit a digital copy to the Swedish Companies Registration Office. Fast, simple and affordable",
      button: "Begin",
      buttonSW: "Börja",
      onClick: navigateToAnnualReport
    },
    {
      image: ServiceSRU,
      title: "Income Declaration 2 - SRU",
      description:
        "Do you lack programs to declare digitally? Through our online service, you can easily create SRU files, which are the Swedish Tax Agency's format for digital forms.",
      button: "Begin",
      buttonSW: "Börja",
      onClick: NavigateToInk2
    },
    {
      image: ServiceNE,
      title: "Income Declaration - NE",
      description:
        "Do you lack programs to declare digitally? Through our online service, you can easily create NE files, which are the Swedish Tax Agency's format for digital forms.",
      button: "Coming Soon",
      buttonSW: "Kommer snart"
    }
  ];

  return (
    <div className="Otherservices-main-div">
      <div className="Otherservices-main-title">
        <span className="Otherservices-span-main">
          <h1> {TranslationFile.serviceTitle1[userSelectedLanguage]}</h1>
        </span>
        <p className="Otherservices-main-title2">
          {TranslationFile.serviceTitle2[userSelectedLanguage]}
        </p>
      </div>
      <div className="other-services-row">
        {servicesList.map((service, index) => (
          <div className="other-services-col" key={index}>
            <div className="other-services-table">
              <div className="service-image-wrapper">
                <img
                  src={service.image}
                  className="service-image"
                  alt={service.title}
                />
              </div>
              <div className="services-text">{service.title}</div>
              <br />
              <div className="services-text-description">
                <p className="services-text-description-p">
                  {service.description}
                </p>
              </div>

              <Button
                label={
                  userSelectedLanguage == "en"
                    ? service.button
                    : service.buttonSW
                }
                // severity="info"
                className="services-begin-button"
                // id="btn_id_other_services"
                onClick={service.onClick}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OtherServices;
